

const crypto = require('crypto');
let KEY = 'ILOVEFETIXFETIX!';
const IV = '!@#$FETIXEVENTiv';

function encrypt(text) {
    // 可直接替換為ofb、cfb、ctr等模式
    let cipher = crypto.createCipheriv('aes-128-cbc', KEY, IV);
    let encrypted = cipher.update(text);
    encrypted = cipher.final();

    return encrypted.toString('hex');
}

function decrypt(text) {
    let encryptedText = new Buffer.from(text, 'hex');
    let decipher = crypto.createDecipheriv('aes-128-cbc', KEY, IV);
    let decrypted = decipher.update(encryptedText);

    decrypted = decipher.final();

    return decrypted.toString();
}

export { encrypt, decrypt };